 import rajan from "../assets/teams/rajan.jpg"
 import gita from "../assets/teams/gita.jpg"
 import loki from "../assets/teams/loki.jpg"
 export const testimonials = [
    {
        avatar: rajan,
        name: "Rajan Bahadur Shahi",
        title: "Founder of meta",
        quote: " Assess the institute's infrastructure, including classrooms, laboratories, and other facilities. A well-equipped institute can contribute to a better learning experience."
    },
    {
        avatar: gita,
        name: "Gita Bista",
        title: "Product designer",
        quote: "A good institute may offer networking opportunities, workshops, and events that can enhance your overall learning experience."
    },
    {
        avatar: loki,
        name: "Lokendra Chaulagain",
        title: "DevOp engineer",
        quote: "Examine the curriculum and course content. Ensure that the institute offers relevant and up-to-date courses that align with your educational and career goals. "
    },
]